import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid mt-5" }
const _hoisted_2 = { class: "d-flex flex-wrap gap-3" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-plug me-2" }),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Integration")
], -1)
const _hoisted_5 = {
  class: "card-body d-flex flex-column justify-content-center",
  style: {"background-color":"#ffe01b"}
}
const _hoisted_6 = { class: "d-flex justify-content-center p-2" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Configure")
const _hoisted_8 = { class: "card" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-hourglass-half me-2" }),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Retention")
], -1)
const _hoisted_10 = { class: "card-body d-flex flex-column align-items-center justify-content-center" }
const _hoisted_11 = { class: "display-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "fw-lighter" }, [
  /*#__PURE__*/_createElementVNode("small", null, "months")
], -1)
const _hoisted_13 = { class: "card" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user me-2" }),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Contacts")
], -1)
const _hoisted_15 = { class: "card-body d-flex align-items-center justify-content-center" }
const _hoisted_16 = { class: "display-4" }
const _hoisted_17 = { class: "progress" }
const _hoisted_18 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_19 = { class: "card" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex align-items-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-mouse me-2" }),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "Events")
], -1)
const _hoisted_21 = { class: "card-body d-flex flex-column align-items-center justify-content-center" }
const _hoisted_22 = { class: "display-4" }
const _hoisted_23 = { class: "progress" }
const _hoisted_24 = ["aria-valuenow", "aria-valuemax"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-end gap-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("i", {
              class: _normalizeClass([_ctx.integrationIconClasses, "fa-5x"])
            }, null, 2)
          ]),
          _createVNode(_component_router_link, {
            to: { name: 'account-integration'},
            type: "button",
            class: "btn btn-sm btn-outline-primary mt-3"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.accountUsage.retentionMonths), 1),
          _hoisted_12
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.accountUsage.usage.contacts.toLocaleString()), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", {
            class: "progress-bar bg-success",
            style: _normalizeStyle({ width: ((_ctx.accountUsage.usage.contacts / _ctx.accountUsage.allowance.contacts) * 100) + '%' }),
            role: "progressbar",
            "aria-valuenow": _ctx.accountUsage.usage.contacts,
            "aria-valuemin": "0",
            "aria-valuemax": _ctx.accountUsage.allowance.contacts
          }, null, 12, _hoisted_18)
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("h1", _hoisted_22, _toDisplayString(_ctx.accountUsage.allowance.events.toLocaleString()), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "progress-bar bg-success",
            style: _normalizeStyle({ width: ((_ctx.accountUsage.usage.events / _ctx.accountUsage.allowance.events) * 100) + '%' }),
            role: "progressbar",
            "aria-valuenow": _ctx.accountUsage.usage.events,
            "aria-valuemin": "0",
            "aria-valuemax": _ctx.accountUsage.allowance.events
          }, null, 12, _hoisted_24)
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#filter-bar-content" }, [
      _hoisted_25
    ]))
  ]))
}